import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/swimming-pool-remodeling")({
  // Legacy alias — permanently redirect to the canonical service page.
  beforeLoad: () => {
    throw redirect({
      to: "/services/pool-remodeling",
      replace: true,
      statusCode: 301,
    });
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex" }],
    links: [
      {
        rel: "canonical",
        href: "https://precisionpaverspools.com/services/pool-remodeling",
      },
    ],
  }),
});
